import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

const handleResponse = async (response, fallbackMessage) => {
  if (!response.ok) {
    let message = fallbackMessage;
    try {
      const data = await response.json();
      message = data.message || message;
    } catch {
      // The response body is not JSON.
    }
    throw new Error(message);
  }
  if (response.status === 204) return null;
  return response.json();
};

const rangeQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.startDate) params.set("startDate", filters.startDate);
  if (filters.endDate) params.set("endDate", filters.endDate);
  if (filters.compare) params.set("compare", filters.compare);
  return params.toString();
};

export const fetchE7seblyPreview = (filters) =>
  fetch(`${API_BASE_URL}/E7sebly/preview?${rangeQuery(filters)}`, { headers: authHeaders() }).then((r) =>
    handleResponse(r, "تعذر تحميل احسبلي")
  );

export const fetchE7seblyDrilldown = (filters, metric, page = 0) => {
  const params = new URLSearchParams(rangeQuery(filters));
  params.set("metric", metric);
  params.set("page", String(page));
  params.set("pageSize", "50");
  return fetch(`${API_BASE_URL}/E7sebly/drilldown?${params}`, { headers: authHeaders() }).then((r) =>
    handleResponse(r, "تعذر تحميل التفاصيل")
  );
};

export const fetchE7seblyInventory = () =>
  fetch(`${API_BASE_URL}/E7sebly/inventory`, { headers: authHeaders() }).then((r) =>
    handleResponse(r, "تعذر تحميل قيمة المخزون")
  );

export const fetchE7seblySettings = () =>
  fetch(`${API_BASE_URL}/E7sebly/settings`, { headers: authHeaders() }).then((r) =>
    handleResponse(r, "تعذر تحميل الإعدادات")
  );

export const fetchE7seblyReports = () =>
  fetch(`${API_BASE_URL}/E7sebly/reports`, { headers: authHeaders() }).then((r) =>
    handleResponse(r, "تعذر تحميل التقارير")
  );

export const fetchE7seblyReport = (id) =>
  fetch(`${API_BASE_URL}/E7sebly/reports/${id}`, { headers: authHeaders() }).then((r) =>
    handleResponse(r, "تعذر تحميل التقرير")
  );

const post = (path, body, fallback) =>
  fetch(`${API_BASE_URL}/E7sebly/${path}`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(body),
  }).then((r) => handleResponse(r, fallback));

export const saveE7seblyExpense = (body) => post("settings/expenses", body, "تعذر حفظ المصروف");
export const saveE7seblyProductCost = (body) => post("settings/product-costs", body, "تعذر حفظ تكلفة المنتج");
export const saveE7seblyConsumable = (body) => post("settings/consumables", body, "تعذر حفظ تكلفة الاستهلاك");
export const saveE7seblySubsidy = (body) => post("settings/subsidies", body, "تعذر حفظ دعم الشحن");
export const saveE7seblyAdSpend = (body) => post("settings/ad-spend", body, "تعذر حفظ مصروف الإعلان");
export const saveE7seblyReturnRate = (body) => post("settings/return-rates", body, "تعذر حفظ نسبة المرتجع");
export const saveE7seblyShippingCost = (body) => post("settings/shipping-costs", body, "تعذر حفظ تكلفة الشحن");
export const saveE7seblyReport = (body) => post("reports", body, "تعذر حفظ التقرير");
export const reviseE7seblyReport = (id, body) => post(`reports/${id}/revise`, body, "تعذر مراجعة التقرير");
